module.exports = __webpack_public_path__ + "static/media/CRV-FTM.8155a60b.png";